import forOwn from 'mout/object/forOwn'
import keys from 'mout/object/keys'
import mergeAnswersByItem from './mergeAnswersByItem';

/*
To Do: 
  eventually, only merge if student hasn't appeared before in the object
*/


export default function mergeGroupUAScoring (prevGUA, newData, subtestId, studentId) {

  let outputScoring = Object.assign({}, prevGUA.scoring)

  let newSubtestCount = 1
  if (prevGUA && prevGUA.scoring && prevGUA.scoring.bySubtest[subtestId]) {
    if (prevGUA.scoring.bySubtest[subtestId].studentCount) {
      newSubtestCount = parseInt(prevGUA.scoring.bySubtest[subtestId].studentCount, 10) + 1
    }
  }


  // merge byNode output
  if (!prevGUA || !prevGUA.scoring || !prevGUA.scoring.byNode[subtestId]) {
    outputScoring.byNode[subtestId] = newData.scoring.byNode[subtestId]
  } else {
    let outputByNode = Object.assign({}, prevGUA.scoring.byNode[subtestId])
    forOwn(newData.scoring.byNode[subtestId], (val, key, o) => {
      if (!outputByNode[key]) {
        outputByNode[key] = val
      } else {
        outputByNode[key].possible += val.possible
        outputByNode[key].raw += val.raw
        outputByNode[key].percentage = outputByNode[key].raw / outputByNode[key].possible
      }
    })
    outputScoring.byNode[subtestId] = outputByNode
  }

  // merge bySubtest output
  if (!prevGUA || !prevGUA.scoring || !prevGUA.scoring.bySubtest[subtestId]) {
    outputScoring.bySubtest[subtestId] = newData.scoring.bySubtest[subtestId]
  } else {
    let outputBySubtest = Object.assign({}, prevGUA.scoring.bySubtest[subtestId])
    const newSubData = newData.scoring.bySubtest[subtestId]
    outputBySubtest.raw += newSubData.raw
    outputBySubtest.possible += newSubData.possible
    outputBySubtest.percentage = outputBySubtest.raw / outputBySubtest.possible
    outputBySubtest.scale = (parseFloat(outputBySubtest.scale) * (newSubtestCount - 1) + parseFloat(newSubData.scale)) / newSubtestCount
    outputBySubtest.studentCount = newSubtestCount
    outputBySubtest.students
    ? outputBySubtest.students = {
      ...outputBySubtest.students,
      [studentId]: true,
    }
    : outputBySubtest.students = {[studentId]: true}
    outputScoring.bySubtest[subtestId] = outputBySubtest
  }

  // merged by test
  if (!newData.scoring.byTest) {
    outputScoring.byTest = prevGUA.scoring.byTest || {}
  } else {
    let newTestCount = 1
    if (prevGUA.scoring.byTest) {
      if (prevGUA.scoring.byTest.studentCount) {
        newTestCount = parseInt(prevGUA.scoring.byTest.studentCount, 10) + 1
      }
    }
    let outputByTest = {}
    if (prevGUA.scoring.byTest) {
      outputByTest = Object.assign({}, prevGUA.scoring.byTest)
    }
    const newTestData = newData.scoring.byTest
    if (keys(outputByTest).length > 0) {
      outputByTest.raw += newTestData.raw
      outputByTest.possible += newTestData.possible
      outputByTest.percentage = outputByTest.raw / outputByTest.possible
      outputByTest.scale = (parseFloat(outputByTest.scale) * (newSubtestCount - 1) + parseFloat(newTestData.scale)) / newSubtestCount
      outputByTest.studentCount = newTestCount
      outputByTest.students 
      ? outputByTest.students = {
        ...outputByTest.students,
        [studentId]: true,
      }
      : outputByTest.students = {[studentId]: true}
    } else {
      outputByTest = newTestData
    }
    outputScoring.byTest = outputByTest
  }
  
  // merged by item
  if (!prevGUA || !prevGUA.scoring || !prevGUA.scoring.byItem[subtestId]) {
    outputScoring.byItem[subtestId] = newData.scoring.byItem[subtestId]
  } else {
    let outputByItem = Object.assign({}, prevGUA.scoring.byItem[subtestId])
    forOwn(newData.scoring.byItem[subtestId], (val, key, o) => {
      if (!outputByItem[key]) {
        outputByItem[key] = val
      } else {
        outputByItem[key].possible += val.possible
        outputByItem[key].raw += val.raw
      }
    })
    outputScoring.byItem[subtestId] = outputByItem
  }

  // merged answersByItem
  let answersByItem
  if (!prevGUA || !prevGUA.answersByItem) {
    answersByItem = newData.answersByItem
  } else {
    answersByItem = mergeAnswersByItem(prevGUA.answersByItem, newData.answersByItem)
  }

  return {
    ...prevGUA,
    answersByItem,
    students: {
      ...prevGUA.students,
      [studentId]: true,
    },
    scoring: {
      ...outputScoring
    },
    upToDate: true,
    lastUpdated: Date.now(),
  }
}


// WEBPACK FOOTER //
// ./src/helpers/assessment/mergeGroupUAScoring.js